
<template>
    <div class="contaier" @touchmove.prevent @click="popupBGClick">
        <div
            :class="['skip-sty', screenHeight >= 812 ? 'maxScreen' : 'minScreen']"
            v-show="newUserGuideType < 3 && newUserGuideType > 0"
            @click="skipnoviceguide"
        >
            跳过新手引导
        </div>
        <!-- 新手气泡引导 -->
        <template v-if="newUserGuideType === 1">
            <div
                class="qpguide-area"
                :style="{ marginTop: qpMarginTop() + 'px' }"
                v-show="benefitInfo || qpGuideList"
            >
                <div
                    :class="['qpLottie-icon', switch3DCat ? 'coinLottie' : 'qpLottie']"
                    @click="qpClick"
                >
                    <Lottie
                        :options="switch3DCat ? defaultOptions3D : defaultOptions"
                        :height="110"
                        :width="110"
                        @animCreated="handleAnimation"
                    ></Lottie>
                    <div :class="['qp-value', switch3DCat ? 'qp-3d' : 'qp-2d']">
                        {{ qipaoItem.afterRewardScore }}
                    </div>
                </div>

                <div :class="['dotted-line', switch3DCat ? 'line-3d' : 'line']">
                    <div class="dotted-circle"></div>
                </div>
                <div class="guide-con">
                    <div class="con-title">
                        <span style="color: #01293c">收</span>
                        <span style="color: #ffbb56">活力值 </span>
                        <span style="color: #01293c">即得新人权益</span>
                    </div>
                    <div class="card-area">
                        <div
                            class="qp-card"
                            v-for="(items, index) in benefitInfo || qpGuideList"
                            :key="index"
                        >
                            <div :class="['card-head', benefitInfo ? 'or-head' : 'blue-head']">
                                {{ items.title }}
                            </div>
                            <div class="card-value">{{ items.desc }}</div>
                            <div class="card-desc">
                                {{ benefitInfo ? '新人专享' : items.value }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- 新手等级权益引导 -->
        <template v-else-if="newUserGuideType === 2">
            <div class="equityGuide-area">
                <div class="top-alert">
                    <div class="alert-title">等级越高，权益越多哦</div>
                </div>
                <div class="my-equitys">
                    <div class="top-title">
                        <div class="left-tit">我的权益</div>
                        <div class="right-tit">
                            <div>全部权益</div>
                            <div class="right-arrow"></div>
                        </div>
                    </div>
                    <div class="equityCards">
                        <div
                            :class="['eq-card', items.type === 2 ? 'item-bg-one' : 'item-bg-two']"
                            v-for="(items, index) in newUserGuidArr"
                            :key="index"
                        >
                            <div class="card-title">{{ items.title }}</div>
                            <div class="card-value">{{ items.desc }}</div>
                            <div :class="buntStyle(items)">
                                {{ butnTitel(items) }}
                            </div>
                            <div class="card-desc" v-if="items.type != 2">
                                {{ items.type === 1 ? '仅限今日' : '新人专享' }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="next-stop">下一步</div>
            </div>
        </template>
        <!-- 做任务领活力值引导 -->
        <template v-else-if="newUserGuideType === 3">
            <div class="dayTask-area">
                <div class="top-alert">
                    <div class="alert-title">做任务，领活力值提升等级</div>
                </div>
                <div class="dayTask-con">
                    <div class="top-title">
                        <div class="left-tit">做任务领活力值</div>
                        <div class="right-tit">
                            <div class="right-desc">更多任务</div>
                            <div class="right-arrow"></div>
                        </div>
                    </div>
                    <div class="crad-area">
                        <div
                            class="card-item"
                            :class="{
                                'item-bg-orange': ['marketing', 'signIn'].includes(item.taskType),
                            }"
                            v-for="(item, index) in taskListData"
                            :key="index"
                        >
                            <div class="card-tit">
                                <div class="tit-text">{{ item.title }}</div>
                                <div class="tit-desc" v-if="item.taskType === 'marketing'">
                                    <span class="desc-prefix">限时</span>
                                    <span>+{{ item.afterRewardScore }}</span>
                                    <span class="desc-suffix">+{{ item.score }}</span>
                                </div>
                                <div class="tit-desc" v-if="item.taskType === 'normal'">
                                    <span>+{{ item.afterRewardScore }}</span>
                                </div>
                            </div>
                            <div class="card-desc">
                                <div class="desc-text">{{ item.desc }}</div>
                                <div
                                    class="right-arrow"
                                    v-if="
                                        ['marketing', 'normal', 'allmore'].includes(item.taskType)
                                    "
                                ></div>
                            </div>
                            <div
                                class="card-btn"
                                :class="{ disabled: item.status === 3 }"
                                v-if="item.taskType === 'signIn'"
                            >
                                {{ item.status === 3 ? '已签到' : '签到' }}
                            </div>
                            <div class="extra-desc flex-box" v-if="item.taskType === 'marketing'">
                                <span>限时悬赏</span>
                                <CountDown
                                    class="count-down-timer"
                                    id="yx-countdownValue"
                                    format="HH:mm:ss"
                                    :time="item.countDown"
                                />
                            </div>
                            <div class="extra-desc" v-if="item.taskType === 'signIn'">
                                剩余{{ item.countDown }}天
                            </div>
                        </div>
                    </div>
                </div>
                <div class="next-confirm">我知道了</div>
            </div>
        </template>
    </div>
</template>
<script>
import * as animationData from '@/assets/qipao-lottie.json';
// import * as coinData from '@/assets/coin.json';
import * as coinDatav1 from '@/assets/coin-v1.json';
import { CountDown } from 'vant';
import Lottie from 'vue-lottie/src/lottie.vue';
export default {
    components: {
        CountDown,
        Lottie
    },
    props: ['newUserGuideType', 'newUserGuidArr', 'scoreInfoData', 'taskListData', 'switch3DCat'],
    data() {
        return {
            defaultOptions3D: {
                animationData: coinDatav1.default,
                render: 'svg', // 要渲染的形式
                loop: true, // 是否重复
                autoplay: true // 是否自动启动
            },
            defaultOptions: {
                animationData: animationData.default,
                render: 'svg', // 要渲染的形式
                loop: true, // 是否重复
                autoplay: true // 是否自动启动
            },
            defaultAnim: '',
            qpGuideList: null,
            benefitInfo: null,
            qipaoItem: {},
            daysTaskArr: [],
            screenHeight: screen.height,
            dataBGURL: [
                'https://inv-growth.oss-cn-hangzhou.aliyuncs.com/guideImage/djqy-guide-bg%402x.png',
                'https://inv-growth.oss-cn-hangzhou.aliyuncs.com/guideImage/djqy-guide-bg2%402x.png'
            ],
            timer: ''
        };
    },
    watch: {
        newUserGuidArr: {
            deep: true,
            immediate: true,
            handler: function(newV, oldV) {
                console.log('newUserGuidArr', newV);
                if (this.newUserGuideType === 1 && newV) {
                    newV.forEach(items => {
                        if (items.taskId === 104 && items.bubbleType === 0) {
                            // 基础分气泡
                            this.qipaoItem = items;
                        }
                    });
                }
            }
        },
        newUserGuideType: {
            deep: true,
            immediate: true,
            handler: function(newV) {
                if (newV > 1) {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'h5_ACT_privilege_xsydmc',
                        tgt_name: 'h5-ACT-成长权益-新手引导蒙层',
                        param: this.scoreInfoData.score,
                        param1: this.scoreInfoData.allScore,
                        param2:
                            newV === 1
                                ? '气泡引导蒙层'
                                : newV === 2
                                    ? '权益引导蒙层'
                                    : '任务引导蒙层',
                        param3: this.switch3DCat ? '是' : '否'
                    });
                }
                if (newV === 1) {
                    window.scrollTo(0, 0);
                    this.getnovicebenefitinfoinnoviceguide();
                } else if (newV === 2) {
                    this.timer = setInterval(() => {
                        window.scrollTo(0, 150);
                    }, 350);
                    this.clearTimer();
                } else if (newV === 3) {
                    window.scrollTo(0, 0);
                    this.getTaskBarSeivice();
                }
            }
        }
    },
    created() {},
    beforeDestroy() {
        if (this.timer) {
            setTimeout(() => {
                clearInterval(this.timer);
            }, 1000);
        }
    },
    methods: {
        async getnovicebenefitinfoinnoviceguide() {
            const { Result, Content } = await this.$http.getnovicebenefitinfoinnoviceguide();
            if (Result === 200) {
                if (Content.noviceBenefitList && Content.noviceBenefitList.length > 3) {
                    const list = Content.noviceBenefitList.splice(0, 3);
                    this.benefitInfo = list;
                } else if (Content.noviceBenefitList) {
                    this.benefitInfo = Content.noviceBenefitList;
                } else {
                    this.qpGuideList = [
                        { title: '免息券', desc: '5~30元', value: '每月可领' },
                        { title: '还款券', desc: '1~6元', value: '每月可领' },
                        { title: '额度成长计划', desc: '5800元', value: '平均提额' }
                    ];
                }
            }
            if (this.benefitInfo) {
                this.benefitInfo.forEach(item => {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'h5_ACT_privilege_xsydmc',
                        tgt_name: 'h5-ACT-成长权益-新手引导蒙层',
                        param: this.scoreInfoData.score,
                        param1: this.scoreInfoData.allScore,
                        param2: '气泡引导蒙层',
                        param3: this.switch3DCat ? '是' : '否',
                        param4: '新人权益',
                        param5: item.title,
                        param6: item.desc,
                        param7: item.couponBatchNo
                    });
                });
            } else {
                this.POINT('h5_element_imp', {
                    page: 'super-成长权益页',
                    tgt_event_id: 'h5_ACT_privilege_xsydmc',
                    tgt_name: 'h5-ACT-成长权益-新手引导蒙层',
                    param: this.scoreInfoData.score,
                    param1: this.scoreInfoData.allScore,
                    param2: '气泡引导蒙层',
                    param3: this.switch3DCat ? '是' : '否',
                    param4: '统一展示类'
                });
            }
        },
        clearTimer() {
            if (this.timer) {
                setTimeout(() => {
                    clearInterval(this.timer);
                }, 1000);
            }
        },
        qpMarginTop() {
            return this.screenHeight >= 812 ? 40 : 44;
        },
        handleAnimation(anim) {
            this.defaultAnim = anim;
        },
        popupBGClick() {
            if (this.newUserGuideType === 1) {
                return;
            }
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege_xsydmc',
                tgt_name: 'h5-ACT-成长权益-新手引导蒙层',
                param: this.scoreInfoData.score,
                param1: this.scoreInfoData.allScore,
                param2:
                    this.newUserGuideType === 1
                        ? '气泡引导蒙层'
                        : this.newUserGuideType === 2
                            ? '权益引导蒙层'
                            : '任务引导蒙层',
                param3: '引导内容',
                param4: this.switch3DCat ? '是' : '否'
            });
            let guideType =
                this.newUserGuideType === 2 ? 'noviceGuideBenefitCard' : 'noviceGuideTaskBar';
            this.markGuideRead(guideType);
        },
        async qpClick() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege_xsydmc',
                tgt_name: 'h5-ACT-成长权益-新手引导蒙层',
                param: this.scoreInfoData.score,
                param1: this.scoreInfoData.allScore,
                param2:
                    this.newUserGuideType === 1
                        ? '气泡引导蒙层'
                        : this.newUserGuideType === 2
                            ? '权益引导蒙层'
                            : '任务引导蒙层',
                param3: '气泡',
                param4: this.switch3DCat ? '是' : '否'
            });
            const { Result } = await this.$http.setNoticeStatus({
                noticeType: 'noviceGuideReceiveBasicScore',
                isRead: true
            });
            if (Result === 200) {
                this.$emit('OnQPGuideClick');
            }
        },
        async skipnoviceguide() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege_xsydmc',
                tgt_name: 'h5-ACT-成长权益-新手引导蒙层',
                param: this.scoreInfoData.score,
                param1: this.scoreInfoData.allScore,
                param2:
                    this.newUserGuideType === 1
                        ? '气泡引导蒙层'
                        : this.newUserGuideType === 2
                            ? '权益引导蒙层'
                            : '任务引导蒙层',
                param3: '跳过按钮',
                param4: this.switch3DCat ? '是' : '否'
            });
            const { Result } = await this.$http.skipnoviceguide({});
            if (Result === 200) {
                console.log('skipnoviceguide');
                this.$emit('OnSkipNoviceGuide');
            }
        },
        async markGuideRead(type) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege_xsydmc',
                tgt_name: 'h5-ACT-成长权益-新手引导蒙层',
                param: this.scoreInfoData.score,
                param1: this.scoreInfoData.allScore,
                param2:
                    this.newUserGuideType === 1
                        ? '气泡引导蒙层'
                        : this.newUserGuideType === 2
                            ? '权益引导蒙层'
                            : '任务引导蒙层',
                param3: '引导内容',
                param4: this.switch3DCat ? '是' : '否'
            });
            const { Result } = await this.$http.setNoticeStatus({
                noticeType: type,
                isRead: true
            });
            if (Result === 200) {
                console.log('mark_guide_read');
                this.$emit('OnMarkGuideRead');
            }
        },
        async getTaskBarSeivice() {
            const { Result, Content } = await this.$http.gettaskbar({});
            if (Result === 200) {
                this.daysTaskArr = Content.taskList;
            }
        },
        // 按钮文案
        butnTitel(item) {
            if (item.benefitKey === 'edcz') {
                return '去查看';
            } else if (item.benefitKey === 'eleme' || item.benefitKey === 'shqy') {
                return '领取';
            } else if (item.benefitKey === 'hxyk') {
                return '去使用';
            } else if (item.benefitKey === 'kfzx') {
                return '去使用';
            } else if (item.benefitKey === 'swlb') {
                return item.benefitStatus === 20 ? '去查看' : '领取';
            } else if (item.benefitKey === 'qyr') {
                let butnTit = '';
                switch (item.benefitStatus) {
                    case 1:
                        butnTit = '每月18日';
                        break;
                    case 21:
                        butnTit = '去使用';
                        break;
                    case 22:
                        butnTit = '下月可领';
                        break;
                    default:
                        butnTit = '领取';
                        break;
                }
                return butnTit;
            } else if (['hfq', 'hkq', 'mxq'].indexOf(item.benefitKey) > -1) {
                if (item.benefitStatus === 20) {
                    return item.receiveMode === 1 ? '已领取' : '下月可领';
                } else if (item.benefitStatus === 21) {
                    return '去使用';
                } else if (item.benefitStatus === 22) {
                    return item.receiveMode === 1 ? '已使用' : '下月可领';
                } else {
                    return '领取';
                }
            } else if (item.benefitKey === 'zkq') {
                return item.buttonText;
            } else if (['fdqy', 'xsqy'].indexOf(item.benefitKey) > -1) {
                let benSta = item.benefitStatus;
                return benSta === 10
                    ? '领取'
                    : benSta === 20
                        ? '已领取'
                        : benSta === 21
                            ? '去使用'
                            : benSta === 22
                                ? '已使用'
                                : benSta === 30
                                    ? '已过期'
                                    : '';
            } else {
                return '';
            }
        },
        buntStyle(item) {
            if (['edcz', 'hxyk', 'kfzx'].indexOf(item.benefitKey) > -1) {
                return 'butn-with-df';
            } else if (['shqy', 'eleme'].indexOf(item.benefitKey) > -1) {
                return 'butn-with-df';
            } else if (item.benefitKey === 'swlb') {
                return 'butn-with-df';
            } else if (item.benefitKey === 'qyr') {
                return item.benefitStatus === 1 || item.benefitStatus === 22
                    ? 'butn-with-gray'
                    : 'butn-with-df';
            } else if (['hfq', 'hkq', 'mxq', 'zkq'].indexOf(item.benefitKey) > -1) {
                if (item.benefitStatus === 20 || item.benefitStatus === 22) {
                    return 'butn-with-gray';
                } else {
                    return 'butn-with-df';
                }
            } else if (['fdqy', 'xsqy'].indexOf(item.benefitKey) > -1) {
                if (
                    item.benefitStatus === 20 ||
                    item.benefitStatus === 22 ||
                    item.benefitStatus === 30
                ) {
                    return 'butn-with-gray';
                } else {
                    return 'butn-with-df';
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
@asserts_4_0: '../../../../assets/iconV4.0/';
.contaier {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 100;
    .maxScreen {
        margin-top: 52px;
    }
    .minScreen {
        margin-top: 38px;
    }
    .skip-sty {
        color: #fff;
        font-size: 12px;
        font-family: 'PingFangSC-Regular, PingFang SC';
        margin-left: 284px;
        text-decoration: underline;
        line-height: 18px;
    }
    .qpguide-area {
        .coinLottie {
            margin-left: 176px;
        }
        .qpLottie {
            margin-left: 110px;
        }
        .qpLottie-icon {
            background-size: 100% 100%;
            width: 120px;
            height: 110px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            .qp-value {
                position: absolute;
                z-index: 8;
                font-size: 11px;
                font-weight: bold;
            }
            .qp-3d {
                margin-top: -8px;
                margin-left: -2px;
                color: #df5d1f;
            }
            .qp-2d {
                color: #fff;
            }
        }
        .line-3d {
            margin-left: 234px;
        }
        .line {
            margin-left: 170px;
        }
        .dotted-line {
            width: 1px;
            height: 30px;
            margin-top: -30px;
            background-color: #fff;
            border: 1px dashed rgba(0, 0, 0, 0.7);
            display: flex;
            align-items: center;
            flex-direction: column;
            .dotted-circle {
                width: 6px;
                height: 6px;
                border-radius: 6px;
                background-color: #fff;
            }
        }
        .guide-con {
            margin: 0px 30px;
            width: 316px;
            height: 163px;
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0px 2px 2px 0px rgba(255, 255, 255, 0.5);
            display: flex;
            flex-direction: column;
            .con-title {
                margin-top: 26px;
                font-size: 16px;
                // font-family: fzlt_bold;
                font-weight: bold;
                text-align: center;
                line-height: 18px;
            }
            .card-area {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 13px 22px 0;
                .qp-card {
                    width: 84px;
                    height: 81px;
                    background-color: #fff;
                    border-radius: 6px;
                    box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.06);
                    border: 1px solid #e7dcd8;
                    text-align: center;
                    margin: 0 5px;
                    .card-head {
                        width: 100%;
                        height: 24px;
                        border-radius: 4px 4px 0px 0px;
                        color: #fff;
                        font-size: 12px;
                        // font-family: fzlt;
                        line-height: 24px;
                    }
                    .or-head {
                        background: linear-gradient(180deg, #ffb03a 0%, #f8a427 100%);
                    }
                    .blue-head {
                        background: linear-gradient(180deg, #7ca9e9 0%, #6396e5 100%);
                    }
                    .card-value {
                        margin-top: 13px;
                        color: #ff4d00;
                        font-size: 13px;
                        // font-family: fzlt_bold;
                        font-weight: bold;
                    }
                    .card-desc {
                        margin-top: 6px;
                        color: #3f5862;
                        font-size: 10px;
                        // font-family: fzlt;
                    }
                }
            }
        }
    }
    .equityGuide-area {
        margin-top: 245px;
        .top-alert {
            margin-left: 30px;
            display: flex;
            flex-direction: row;
            align-items: center;
            .alert-title {
                padding: 0px 16px;
                color: #fff;
                font-size: 14px;
                // font-family: fzlt_bold;
                font-weight: 400;
                line-height: 36px;
                text-align: center;
                background: linear-gradient(315deg, #4891d8 0%, #67a5e2 100%);
                border-radius: 20px;
                position: relative;
                &::after {
                    content: '';
                    position: absolute;
                    left: 37px;
                    bottom: -11px;
                    width: 0px;
                    height: 0px;
                    border: 6px solid;
                    border-color: #67a5e2 transparent transparent transparent;
                }
            }
        }
        .my-equitys {
            margin-top: 14px;
            width: 100%;
            height: 200px;
            background-color: #fff;
            border-radius: 5px;
            .top-title {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 28px 18px 0;
                line-height: 18px;
                .left-tit {
                    color: #002a3c;
                    font-size: 18px;
                    // font-family: fzlt_bold;
                    font-weight: 600;
                }
                .right-tit {
                    color: #254d5e;
                    font-size: 13px;
                    // font-family: fzlt;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .right-arrow {
                        margin-left: 4px;
                        background-size: 100% 100%;
                        width: 6px;
                        height: 10px;
                        background-image: url('@{asserts}/mygrade-arrow@2x.png');
                    }
                }
            }
            .equityCards {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: nowrap;
                padding: 19px 10px 6px 17px;
                overflow: hidden;
                .item-bg-one {
                    background-image: url('@{asserts_4_0}/coupon-card@2x.png');
                }
                .item-bg-two {
                    background-image: url('@{asserts_4_0}/floatCoupon-card@2x.png');
                }
                .eq-card {
                    width: 78px;
                    min-width: 78px;
                    height: 108px;
                    background-size: 100% 100%;
                    text-align: center;
                    margin-right: 4px;
                    .card-title {
                        margin-top: 7px;
                        font-size: 12px;
                        line-height: 13px;
                        color: #fff;
                        // font-family: fzlt_bold;
                        font-weight: 400;
                    }
                    .card-value {
                        margin-top: 18px;
                        color: #3f5862;
                        font-size: 14px;
                        line-height: 13px;
                        // font-family: fzlt;
                        font-weight: 400;
                    }
                    .card-desc {
                        margin-top: -35px;
                        color: #ff4d00;
                        font-size: 12px;
                        transform: scale(0.75);
                        line-height: 11px;
                        // font-family: fzlt;
                    }
                    .butn-with-df {
                        margin: 18px 9px 0;
                        width: 60px;
                        height: 20px;
                        border-radius: 10px;
                        font-size: 11px;
                        // font-family: fzlt_bold;
                        font-weight: 400;
                        line-height: 20px;
                        background-image: url('@{asserts}/benefit-butn.gif');
                        background-size: 100% 100%;
                        color: #fff;
                    }
                    .butn-with-gray {
                        margin: 20px 0 0;
                        width: 100%;
                        height: 20px;
                        font-size: 12px;
                        line-height: 17px;
                        // font-family: fzlt_bold;
                        font-weight: 400;
                        color: #c8c8c8;
                    }
                }
            }
        }
        .next-stop {
            margin: 20px 130px 0;
            width: 114px;
            height: 36px;
            border-radius: 18px;
            opacity: 0.9;
            border: 1px solid #ffffff;
            color: #fff;
            font-size: 13px;
            // font-family: fzlt;
            text-align: center;
            line-height: 36px;
        }
    }
    .dayTask-area {
        margin-top: 280px;
        .top-alert {
            margin-left: 30px;
            display: flex;
            flex-direction: row;
            align-items: center;
            .alert-title {
                padding: 0px 16px;
                color: #fff;
                font-size: 14px;
                // font-family: fzlt_bold;
                font-weight: 400;
                line-height: 36px;
                text-align: center;
                background: linear-gradient(315deg, #4891d8 0%, #67a5e2 100%);
                border-radius: 20px;
                position: relative;
                &::after {
                    content: '';
                    position: absolute;
                    left: 37px;
                    bottom: -11px;
                    width: 0px;
                    height: 0px;
                    border: 6px solid;
                    border-color: #67a5e2 transparent transparent transparent;
                }
            }
        }
        .dayTask-con {
            margin-top: 14px;
            width: 100%;
            height: 145px;
            background-color: #d4e7f9;
            border-radius: 5px;
            .top-title {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 18px 18px 0;
                line-height: 18px;
                .left-tit {
                    color: #002a3c;
                    font-size: 18px;
                    font-weight: 600;
                }
                .right-tit {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .right-desc {
                        color: #254d5e;
                        font-size: 13px;
                    }
                    .right-arrow {
                        margin-left: 4px;
                        width: 6px;
                        height: 10px;
                        background-size: 100% 100%;
                        background-image: url('@{asserts}/mygrade-arrow@2x.png');
                    }
                }
            }
            .crad-area {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: nowrap;
                padding: 20px 18px 10px;
                overflow: hidden;
                .card-item {
                    width: 225px;
                    min-width: 225px;
                    height: 70px;
                    border-radius: 5px;
                    border: 1px solid #ffffff;
                    background: #ffffff;
                    padding: 16px 0px 16px 12px;
                    margin-right: 8px;
                    position: relative;
                    &.item-bg-orange {
                        background: linear-gradient(180deg, #fef7ec 0%, #ffe0c7 100%);
                    }
                    .card-tit {
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        flex-wrap: nowrap;
                        .tit-text {
                            font-size: 14px;
                            font-weight: 600;
                            color: #863e1e;
                            line-height: 20px;
                        }
                        .tit-desc {
                            margin-left: 4px;
                            font-size: 12px;
                            font-weight: bold;
                            color: #f6652f;
                            line-height: 17px;
                            border-radius: 8px 3px 3px 8px;
                            padding: 0px 5px 0px 21px;
                            background-color: #ffdaa4;
                            background-image: url('@{asserts_4_0}/VIP-icon@2x.png');
                            background-position: left center;
                            background-size: 17px 17px;
                            background-repeat: no-repeat;
                            .desc-prefix {
                                font-size: 11px;
                                font-weight: normal;
                            }
                            .desc-suffix {
                                font-size: 11px;
                                font-weight: normal;
                                color: #f6a986;
                                text-decoration: line-through;
                                margin-left: 3px;
                            }
                        }
                    }
                    .card-desc {
                        margin-top: 4px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        flex-wrap: nowrap;
                        max-width: 363px;
                        overflow: hidden;
                        .desc-text {
                            font-size: 11px;
                            font-weight: 400;
                            color: #863e1e;
                            opacity: 0.65;
                            line-height: 16px;
                            white-space: nowrap;
                        }
                        .right-arrow {
                            margin-left: 4px;
                            width: 6px;
                            height: 6px;
                            background-size: 100% 100%;
                            background-image: url('@{asserts}/arrow-right@2x.png');
                        }
                    }
                    .card-btn {
                        position: absolute;
                        top: 22px;
                        right: 9px;
                        width: 56px;
                        height: 24px;
                        background: #ffffff;
                        box-shadow: 0px 2px 7px 0px rgba(255, 176, 113, 0.5);
                        border-radius: 12px;
                        font-size: 12px;
                        font-weight: 600;
                        color: #ff6a00;
                        text-align: center;
                        line-height: 24px;
                        &.disabled {
                            color: #ffc297;
                        }
                    }
                    .extra-desc {
                        position: absolute;
                        top: 0;
                        transform: translateY(-50%);
                        right: -1px;
                        padding: 3px 9px;
                        height: 20px;
                        background: linear-gradient(90deg, #ff8300 0%, #ffb974 100%);
                        box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
                        border-radius: 10px 10px 0px 10px;
                        font-size: 10px;
                        font-weight: 600;
                        color: #ffffff;
                        text-align: center;
                        line-height: 14px;
                        &.flex-box {
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: center;
                        }
                        .count-down-timer {
                            font-size: 10px;
                            font-weight: 600;
                            color: #ffffff;
                            text-align: center;
                            line-height: 14px;
                            margin-left: 5px;
                        }
                    }
                }
            }
        }
        .next-confirm {
            margin: 40px 130px 0;
            width: 114px;
            height: 36px;
            border-radius: 18px;
            opacity: 0.9;
            border: 1px solid #ffffff;
            color: #fff;
            font-size: 13px;
            // font-family: fzlt;
            text-align: center;
            line-height: 36px;
        }
    }
}
</style>